<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { Head, Link, useForm, router } from '@inertiajs/vue3';
import { useTheme, useDisplay } from 'vuetify'
import AuthenticationCard from '@/Components/AuthenticationCard.vue';
import AuthenticationCardLogo from '@/Components/AuthenticationCardLogo.vue';
import Checkbox from '@/Components/Checkbox.vue';
import InputError from '@/Components/InputError.vue';
import InputLabel from '@/Components/InputLabel.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import TextInput from '@/Components/TextInput.vue';
import { useThemeStore } from '@/Stores/Theme';
import { useAuth } from '@/Composables/Auth';
import AuthLayout from '@/Layouts/AuthLayout.vue';

defineOptions({
    layout: AuthLayout
})

defineProps({
    canResetPassword: Boolean,
    status: String,
});


const theme = useTheme();
const themeStore = useThemeStore();
const { isLoggedIn } = useAuth();

const passwordInput = ref(null);
const passwordInputVisible = ref(false);

const form = useForm({
    email: '',
    password: '',
    remember: false,
});

const submit = () => {
    form.transform(data => ({
        ...data,
        remember: form.remember ? 'on' : '',
    })).post(route('login'), {
        onFinish: () => form.reset('password'),
    });
};
document.documentElement.setAttribute('data-theme', themeStore.getColorScheme);
watch(() => themeStore.getColorScheme, (newValue) => {
    // console.log(theme.global.name.value, themeStore.getColorScheme);
    theme.global.name.value = themeStore.getColorScheme;
    document.documentElement.setAttribute('data-theme', themeStore.getColorScheme);
});
onMounted(() => {
    router.reload();
})
console.log(isLoggedIn.value)
</script>

<template>
    <Head title="Sign In" />
    <AuthenticationCard>
        <template #logo>
            <AuthenticationCardLogo />
        </template>

        <div v-if="status" class="mb-4 text-body-1 text-success">
            {{ status }}
        </div>

        <form @submit.prevent="submit">
            <div class="d-flex flex-column ga-4 pt-3 pb-2">
                <div>
                    <v-text-field
                        v-model="form.email"
                        label="Email"
                        variant="outlined"
                        :error-messages="form.errors.email"
                        required
                    ></v-text-field>
                </div>
                <div>
                    <v-text-field
                        label="Password"
                        v-model="form.password"
                        ref="passwordInput"
                        :type="passwordInputVisible ? 'text' : 'password'"
                        placeholder="Enter your password"
                        variant="outlined"
                        :error-messages="form.errors.password"
                        required
                    >
                        <template #append-inner >
                            <span role="button" @click="passwordInputVisible = !passwordInputVisible">
                                <mdi-icon v-if="passwordInputVisible">visibility</mdi-icon>
                                <mdi-icon v-else>visibility_off</mdi-icon>
                            </span>
                        </template>
                    </v-text-field>
                </div>
                <div class="d-flex align-center justify-end">
                    <!-- <Link v-if="canResetPassword" :href="route('password.request')" class="underline text-sm text-gray-600 hover:text-gray-900 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Forgot your password?
                    </Link> -->
                    <v-btn type="submit" color="primary" block size="x-large" variant="flat" :disabled="form.processing" :loading="form.processing">Sign In</v-btn>
                </div>
            </div>

            <!-- <div class="block mt-4">
                <label class="flex items-center">
                    <Checkbox v-model:checked="form.remember" name="remember" />
                    <span class="ms-2 text-sm text-gray-600">Remember me</span>
                </label>
            </div> -->

            
        </form>
    </AuthenticationCard>
</template>
